// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.lmShare = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body')
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();


			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);

			settings.$facebookShare = $context.find('.share__facebook');
			settings.$shareQuote = $context.find('.share__quote');
		};

		// Toggle Active Classes
		methods.toggle = function() {
			$context.toggleClass(settings.activeClass);
		};

		// Bind events
		methods.events = function() {

			settings.$facebookShare.on('click.lmShare', function() {
				var $this = $(this),
					quote = $this.data('share-text'),
					url = $this.data('share-url');

				FB.ui({
					quote: quote,
					method: 'share',
					display: 'popup',
					href: url
				});
			});
		};

		// On load function.
		methods.initContext = function() {
			methods.setCurrentSettings();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});

	};

	if ($('.share').length) {
		$('.share').lmShare();
	}

}(jQuery));
